import React, { useEffect, useState } from 'react'

import { EditorForm } from './EditorForm/EditorForm'
import { Review } from './Review/Review'
import style from './SimulatorInterface.module.css'
import { TaskDisplay } from './TaskDisplay/TaskDisplay'

import { useAppDispatch, useAppSelector } from 'common/hooks'
import { TaskDomain } from 'features/dashboard'
import { resetSimulator, selectIsCompleted, setTask } from 'features/simulator'

type PropsType = {
  task: TaskDomain
}

export const SimulatorInterface = ({ task }: PropsType) => {
  const dispatch = useAppDispatch()
  const isCompleted = useAppSelector(selectIsCompleted)
  const [scrollTop, setScrollTop] = useState(0)

  useEffect(() => {
    dispatch(setTask(task))

    return () => {
      dispatch(resetSimulator())
    }
  }, [task.id])

  return (
    <div className={style.box}>
      <TaskDisplay task={task} scrollTop={scrollTop} />
      {isCompleted ? <Review /> : <EditorForm task={task} setScrollTop={setScrollTop} />}
    </div>
  )
}
